import axios from "axios";
import { API_END_POINT } from "../../../constants/api";

const authConfig = () => ({
  headers: {
    "Content-Type": "application/json",
    Authorization: `Bearer ${localStorage.getItem("usertoken")}`,
  },
});

export function addPayment(paymentData) {
  return axios.post(
    `${API_END_POINT}/api/company/contract/payment/register`,
    paymentData,
    authConfig()
  );
}

export function getPayments(contractId, companyId) {
  return axios.get(
    `${API_END_POINT}/api/company/contract/payment/get/${contractId}/${companyId}`,
    authConfig()
  );
}

export function getCompanyPayments(companyId) {
  return axios.get(
    `${API_END_POINT}/api/company/contract/payment/company/${companyId}`,
    authConfig()
  );
}

export function updatePayment(paymentId, paymentData) {
  return axios.put(
    `${API_END_POINT}/api/company/contract/payment/update/${paymentId}`,
    paymentData,
    authConfig()
  );
}

export function deletePayment(paymentId, companyId) {
  return axios.delete(
    `${API_END_POINT}/api/company/contract/payment/delete/${paymentId}/${companyId}`,
    authConfig()
  );
}
